import { render, staticRenderFns } from "./VideoCameraIcon.vue?vue&type=template&id=05aac158&"
import script from "./VideoCameraIcon.vue?vue&type=script&lang=js&"
export * from "./VideoCameraIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports